import Employee from '@/models/Employee';
import VerifyBug from '@/mixins/VerifyBug';

export default class QA extends Employee {
  constructor({ team, index, productivity }) {
    super({ team, index, productivity });
    this.addSkill(new VerifyBug(this));
  }
}
